<template>
  <soha-page-loading v-if="loading" />
  <div v-else class="card card-custom gutter-b example example-compact p-8">
    <div class="mb-10 d-flex align-items-center justify-content-between">
      <div>
        <span class="svg svg-icon svg-icon-primary">
          <inline-svg src="/media/svg/soha/icons/headset.svg" />
        </span>
        <span class="card-label pl-1 soha-page-title">
          {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
        </span>
      </div>
      <div>
        <soha-modal
          :title="$t(`${I18nPrefix}CREATE_TICKET`)"
          id="insert-ticket"
          @hide="clearModalData()"
          hide-footer
        >
          <template v-slot:activator>
            <soha-button
              name="modalActivator"
              @click="$bvModal.show('insert-ticket')"
              :text="$t(`${I18nPrefix}CREATE_TICKET`)"
              icon="plus"
            />
          </template>
          <template v-slot:body>
            <div class="row justify-content-center">
              <div class="col-12">
                <soha-text-field
                  name="subject"
                  v-model="ticketSubject.value"
                  :error="ticketSubject.error"
                  class="w-100"
                  :placeholder="$t(`${I18nPrefix}SUBJECT`)"
                />
              </div>
              <div class="col-12">
                <soha-select
                  class="w-100"
                  :placeholder="$t(`${I18nPrefix}DEPARTMENT`)"
                  name="department"
                  :options="departments"
                  v-model="department.value"
                  :error="department.error"
                />
              </div>
              <div class="col-12">
                <soha-select
                  class="w-100"
                  :placeholder="$t(`${I18nPrefix}PRIORITY`)"
                  name="priority"
                  :options="priorities"
                  v-model="priority.value"
                  :error="priority.error"
                />
              </div>
              <div class="col-12">
                <label class="mt-2 mb-0 font-size-h6">
                  {{ $t(`${I18nPrefix}TEXT`) }}
                </label>
                <soha-text-editor
                  name="ticketText"
                  v-model="ticketText.value"
                  :style="
                    ticketText.error
                      ? 'border: 1px solid red !important; border-radius: 5px;'
                      : ''
                  "
                />
                <span class="font-size-sm text-red" v-if="ticketText.error">
                  {{ $t(`${I18nPrefix}TICKET_TEXT_ERROR`) }}
                </span>
              </div>
              <div class="col-12 mt-5">
                <soha-button
                  name="createBtn"
                  :loading="createBtnLoading"
                  @click="createTicket"
                  class="w-100"
                  :text="$t(`${I18nPrefix}INSERT`)"
                />
              </div>
            </div>
          </template>
        </soha-modal>
      </div>
    </div>
    <soha-no-data
      v-if="!tickets.length"
      :message="$t(`${I18nPrefix}NO_DATA`)"
    />
    <div v-for="ticket in tickets" :key="ticket.id" v-else>
      <router-link
        :to="{ name: 'ticket-detail', query: { id: ticket.id } }"
        style="color: inherit"
      >
        <soha-ticket-card :ticket="ticket" />
      </router-link>
    </div>
    <div class="mt-5">
      <b-pagination
        v-if="totalTicketCount > perPage"
        align="center"
        pills
        @input="goToPage"
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="totalTicketCount"
        name="pagination"
      />
    </div>
  </div>
</template>

<script>
import SohaTicketCard from "@/view/components/ticket/TicketCard";
import ValidationMixin from "@/mixins/ValidationMixin";
import UIMixin from "@/mixins/UIMixin";
import ApiService from "@/core/services/api.service";
export default {
  name: "index",

  mixins: [ValidationMixin, UIMixin],

  components: {
    SohaTicketCard,
  },

  data() {
    return {
      I18nPrefix: "PAGES.TICKET.INDEX.",
      loading: false,
      totalTicketCount: null,
      perPage: null,
      currentPage: null,
      ticketSubject: {
        value: null,
        error: null,
      },
      departments: [
        {
          id: "1",
          text: "فنی",
        },
        {
          id: "2",
          text: "بازرگانی",
        },
        {
          id: "3",
          text: "مالی",
        },
        {
          id: "4",
          text: "مدیریت",
        },
      ],
      priorities: [
        {
          id: "3",
          text: "عادی",
        },
        {
          id: "2",
          text: "مهم",
        },
        {
          id: "1",
          text: "فوری",
        },
      ],
      department: {
        value: null,
        error: null,
      },
      priority: {
        value: null,
        error: null,
      },
      ticketText: {
        value: null,
        error: null,
      },
      createBtnLoading: false,
      tickets: [],
    };
  },

  mounted() {
    this.currentPage = this.$route.query.page ?? 1;
    this.getTickets(true);
  },

  methods: {
    getTickets(loading) {
      this.loading = loading;
      ApiService.get(`api/v2/tickets`, {
        page: this.currentPage,
      }).then(({ data }) => {
        if (!data.code) {
          this.tickets = data.data;
          this.totalTicketCount = data.total;
          this.currentPage = data.current_page;
          this.perPage = data.per_page;
        } else {
          this.errorToast(data.message);
        }
        this.loading = false;
      });
    },

    createTicket() {
      this.ticketSubject.error = this.validateField(
        this.ticketSubject.value,
        this.$t(`${this.I18nPrefix}SUBJECT`)
      );
      this.department.error = this.validateField(
        this.department.value,
        this.$t(`${this.I18nPrefix}DEPARTMENT`),
        0,
        "select"
      );
      this.priority.error = this.validateField(
        this.priority.value,
        this.$t(`${this.I18nPrefix}PRIORITY`),
        0,
        "select"
      );
      this.ticketText.error =
        this.ticketText.value ==
        `<p class="ql-direction-rtl ql-align-right"><br></p>`;
      if (
        this.ticketSubject.error ||
        this.department.error ||
        this.priority.error ||
        this.ticketText.error
      )
        return;
      this.createBtnLoading = true;
      ApiService.post(`api/v2/tickets`, {
        title: this.ticketSubject.value,
        department: this.department.value,
        priority: this.priority.value,
        message: this.ticketText.value,
      }).then(({ data }) => {
        if (data.code == 201) {
          this.successToast(data.message);
          this.$bvModal.hide("insert-ticket");
          this.getTickets();
        } else {
          this.errorToast(data.message);
        }
        this.createBtnLoading = false;
      });
    },

    clearModalData() {
      this.ticketSubject = {
        value: null,
        error: null,
      };
      this.department = {
        value: null,
        error: null,
      };
      this.priority = {
        value: null,
        error: null,
      };
      this.ticketText = {
        value: null,
        error: null,
      };
      this.createBtnLoading = false;
    },

    goToPage() {
      this.$router.push({ query: { page: this.currentPage } });
      this.getTickets();
    },
  },
};
</script>
